import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import Bredcrumb from "../components/Bredcrumb";

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;

const TermCondition = () => {
  return (
    <>
      <CustomHelmet
        title="Terms and Conditions - Arcaptor Technologies"
        description="Review the Terms and Conditions for using services offered by Arcaptor Technologies. Understand the guidelines, responsibilities, and legal information to ensure a secure and smooth experience."
      />
      <MainLayout>
        <Bredcrumb
          paddingY="30px"
          imgStyleHeight="300px"

          heading="Terms and Conditions"
          image="./images/Terms.png"
        />
        <Container>
          <TextContent>
            <h2 className="main_heading">Term & Conditions</h2>
            <p>
              Welcome to the ARCAPTOR TECHNOLOGIES website. By accessing or
              using this site, you agree to be bound by the following terms and
              conditions ("Terms"). Please read them carefully. If you do not
              agree with any part of these Terms, kindly refrain from using this
              site.
            </p>
            <br />
            <h4>Terms of Use</h4>
            <br />
            <h4>1.General Information</h4>
            <br />
            <ul>
              <li>
                The content on this website is provided for general information
                and use only. It is subject to change without prior notice.
              </li>
            </ul>
            <br />
            <h4>2.Cookies</h4>
            <br />
            <ul>
              <li>
                This website uses cookies to monitor browsing preferences. If
                you permit cookies, certain personal information may be
                collected and used by third parties.
              </li>
            </ul>
            <br />
            <h4>3.Accuracy and Liability</h4>
            <br />
            <ul>
              <li>
                ARCAPTOR TECHNOLOGIES and third parties make no warranties or
                guarantees regarding the accuracy, timeliness, performance,
                completeness, or suitability of the information and materials
                found or offered on this site for any specific purpose. Such
                information may contain errors, and ARCAPTOR TECHNOLOGIES
                disclaims all liability for any inaccuracies to the fullest
                extent permitted by law.
              </li>
              <li>
                Any use of the information or materials on this website is at
                your own risk. It is your responsibility to ensure that any
                products, services, or information meet your specific
                requirements.
              </li>
            </ul>
            <br />
            <h4>4.Intellectual Property</h4>
            <br />
            <ul>
              <li>
                All materials on this website, including the design, layout,
                appearance, and graphics, are owned by or licensed to ARCAPTOR
                TECHNOLOGIES. Unauthorized reproduction of such material is
                prohibited and subject to copyright laws, which form part of
                these Terms.
              </li>
              <li>
                The name "ARCAPTOR" and all associated trademarks or registered
                trademarks, including products and logos denoted with “TM” or
                “®,” are the exclusive property of ARCAPTOR TECHNOLOGIES or its
                affiliates. These trademarks must not be used in connection with
                any unauthorized products, functions, or services.
              </li>
            </ul>

            <br />
            <h4>5.Prohibited Use</h4>
            <br />
            <ul>
              <li>
                Unauthorized use of this website may lead to legal action,
                including claims for damages or criminal prosecution.
              </li>
            </ul>

            <br />
            <h4>6.Third-Party Links</h4>
            <br />
            <ul>
              <li>
                This website may include links to external websites for your
                convenience. These links do not imply endorsement by ARCAPTOR
                TECHNOLOGIES, and we are not responsible for the content of
                these external websites.
              </li>
            </ul>
            <br />
            <h4>Governing Law and Jurisdiction</h4>
            <br />
            <ul>
              <li>
                These Terms are governed by the laws of India, irrespective of
                conflict-of-law provisions.
              </li>
              <li>
                In case of disputes arising from these Terms or the use of this
                website, all such matters shall be exclusively subject to the
                jurisdiction of the courts located in Delhi, India.
              </li>
            </ul>
            <br />

            <p>
              By using this website, you agree to abide by these Terms and
              Conditions. <b>ARCAPTOR TECHNOLOGIES</b> reserves the right to
              modify these Terms at any time without prior notice.
            </p>
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default TermCondition;
